import { render, staticRenderFns } from "./buyerBehaviorHistory.vue?vue&type=template&id=0e5ee1ea&scoped=true&"
import script from "./buyerBehaviorHistory.vue?vue&type=script&lang=js&"
export * from "./buyerBehaviorHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5ee1ea",
  null
  
)

export default component.exports